import posthog from 'posthog-js';
import { createContext, useContext, useState, useCallback } from 'react';
import { useQuery } from 'react-query';
import { useStore } from '../../components/store-provider/use-store';
import { getThread } from '../api/chat';
import { parseThreadToChat } from '../helpers/assistant';

const AssistantChatContext = createContext();

export const useAssistantChat = () => useContext(AssistantChatContext);

export const AssistantChatProvider = ({ children }) => {
  // State to manage the thread.
  const [thread, setThread] = useState(null);

  // Using the store to get the guide data.
  const {
    data: { pages: guide },
  } = useStore();

  // Using posthog to get the session ID to link messages to the current session.
  const threadId = posthog.get_session_id();

  const { isLoading } = useQuery(['getThread'], () => getThread({ guide, threadId }), {
    select: (thread) => (thread ? parseThreadToChat(thread) : []),
    onSuccess: (selectedData) => {
      setThread(selectedData);
    },
  });

  // message: { sender: 'user' | 'assistant', text: string, timestamp: Date }
  const addMessage = useCallback((message) => {
    setThread((prev) => {
      if (prev === null) {
        return [{ ...message, timestamp: new Date() }];
      }
      return [...prev, { ...message, timestamp: new Date() }];
    });
  }, []);

  // Memoize the context value to avoid unnecessary re-renders
  const contextValue = {
    guide,
    threadId,
    thread,
    isLoading,
    addMessage,
  };

  return <AssistantChatContext.Provider value={contextValue}>{children}</AssistantChatContext.Provider>;
};
